import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_tree = _resolveComponent("ui-tree")!
  const _component_ui_group_option = _resolveComponent("ui-group-option")!
  const _component_ui_group = _resolveComponent("ui-group")!

  return (_openBlock(), _createBlock(_component_ui_group, {
    title: $props.title || '',
    "border-top": $props.border
  }, {
    icon: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ui_group_option, null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_ui_tree, {
            data: $props.list,
            open: "",
            stroke: "",
            "max-tab": 4,
            key: $setup.key
          }, {
            default: _withCtx(({ row, locals }) => [
              (!($props.customs && $props.customs.includes(row)))
                ? (_openBlock(), _createBlock($setup["TreeAtom"], {
                    key: 0,
                    onClick: _withModifiers(($event: any) => ($setup.emit('click', row)), ["stop"]),
                    icon: $setup.icons[row.type],
                    iconColor: 
              row.type === 'dataset' ? row.origin.color : 'rgba(255,255,255,.6)'
            ,
                    active: $props.highlight && $props.highlight.includes(row),
                    class: _normalizeClass(["data-set-tree-atom", {
              unassigned: row.unassigned,
              disabled: $props.joinSelect && !$setup.getTreeSelect(locals).select
            }]),
                    atom: row,
                    title: row.type === 'dataset' ? row.origin.title : row.title,
                    desc: row.type === 'dataset' ? row.origin.shootTime : '',
                    style: _normalizeStyle({ zIndex: 100000000 - Number(locals.join('')) })
                  }, {
                    ctrl: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "prectrl", {
                        raw: row,
                        locals: locals,
                        select: $setup.getTreeSelect(locals).select
                      }, undefined, true),
                      (
                  !$props.disabledSelect &&
                  (row.type !== 'label' || row.children?.length)
                )
                        ? (_openBlock(), _createBlock(_component_ui_input, {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                            class: "select",
                            type: "checkbox",
                            modelValue: $setup.getTreeSelect(locals).select,
                            "onUpdate:modelValue": ($event: any) => (($setup.getTreeSelect(locals).select) = $event),
                            disabled: $setup.customMap.mode === $setup.Mode.pano
                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled"]))
                        : _createCommentVNode("v-if", true),
                      _renderSlot(_ctx.$slots, "ctrl", {
                        raw: row,
                        locals: locals,
                        select: $setup.getTreeSelect(locals).select,
                        selectData: $setup.getTreeSelect(locals)
                      }, undefined, true)
                    ]),
                    foot: _withCtx((data) => [
                      _renderSlot(_ctx.$slots, "foot", _mergeProps(data, {
                        select: $setup.getTreeSelect(locals).select
                      }), undefined, true)
                    ]),
                    label: _withCtx((data) => [
                      _renderSlot(_ctx.$slots, "label", _mergeProps(data, {
                        select: $setup.getTreeSelect(locals).select
                      }), undefined, true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "icon", "iconColor", "active", "class", "atom", "title", "desc", "style"]))
                : _renderSlot(_ctx.$slots, "custom-tree", {
                    key: 1,
                    raw: row,
                    locals: locals
                  }, undefined, true)
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["data"]))
        ]),
        _: 3 /* FORWARDED */
      })
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title", "border-top"]))
}